import { useEffect, useState } from 'react';

import { BalanceType, ContractBalanceOf } from '@/types';
import { useWeb3 } from '@/hooks/use-web3';
import { fiexdDecimal, NumWithComma } from '@/lib/BigNumbers';
import { METHODS_BALANCE_OF } from '@/lib/common/name-space';
import { weiToEth } from '@/lib/web3/utils';
import { ticker } from '@/api/server/common/ticker';
import BigNumber from 'bignumber.js';

export default function UsdtBalance(payload: BalanceType) {
  const { chainId, symbol, token } = payload;
  const { web3authCall } = useWeb3();
  const [amount, setAmount] = useState('0');
  useEffect(() => {
    (async () => {
      if (web3authCall?.connected()) {
        const address = await web3authCall.getAddress();
        let res = null;
        if (token) {
          const obj = {
            symbol,
            amount: '1',
          };
          const tickers = await ticker(obj);
          // erc20
          const payload = {
            method: METHODS_BALANCE_OF,
            symbol,
            address,
          };
          const amt = await web3authCall.getRpc().contractCall<ContractBalanceOf>(payload);
          const usdt = BigNumber(amt).multipliedBy(tickers.data.latest_price).toFixed(0);
          res = NumWithComma(fiexdDecimal(weiToEth(usdt)));
        } else {
          // 기반 코인
          res = NumWithComma(fiexdDecimal(await web3authCall.getRpc().getBalance(address)));
        }
        setAmount(res ? res : '0');
        // const re = await web3authCall.getRpc().getBalance(token, symbol, address);
        // console.log(`balance`);
        // console.log(re);
      }
    })();
    return () => {};
  }, [symbol, chainId, token, web3authCall]);

  return <>{amount} usdt</>;
}
